module.exports = __webpack_public_path__ + "media/images/gfx/cancel_xs-1380b226f8d612f127b222d205dbc5ab.gif";